/**
 * Keuzelijsten op alfabet (eigenaar 02-10-2026: "Deze moeten wel in
 * alfabetische volgorde gezet worden, doe dat altijd"). Zie
 * DESIGN-SYSTEM.md, "Keuzelijsten".
 *
 * - Hoofdletters tellen niet ("big chance" naast "Big Chance").
 * - Getallen op hun waarde: "U9" vóór "U10", "Team 2" vóór "Team 10".
 * - Wat in `achteraan` staat (bijv. "Overig" of "Geen categorie") komt
 *   altijd onderaan, ongeacht de naam.
 */
const VERGELIJKER = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export function alfabetisch(a: string, b: string): number {
  return VERGELIJKER.compare(a ?? '', b ?? '');
}

/** Sorteer op een naam; de waarden in `achteraan` onderaan, in hun eigen volgorde. */
export function opAlfabet<T>(lijst: readonly T[], naam: (item: T) => string, achteraan: readonly string[] = []): T[] {
  const plek = (item: T) => {
    const i = achteraan.indexOf(naam(item));
    return i === -1 ? -1 : i;
  };
  return [...lijst].sort((a, b) => {
    const pa = plek(a);
    const pb = plek(b);
    if (pa !== pb) {
      return pa === -1 ? -1 : pb === -1 ? 1 : pa - pb;
    }
    return alfabetisch(naam(a), naam(b));
  });
}
